import { forwardRef } from 'react';
import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  unstable_extendSxProp as extendSxProp,
  type SystemProps,
} from '@mui/system';

// MUI v9 removed system style props (gap, alignItems, flexWrap, etc.) from Stack
// in favour of the `sx` prop. We keep the old ergonomics by accepting system
// props and folding them into `sx` at runtime via MUI's `extendSxProp` helper.
export type StackProps = MuiStackProps & SystemProps<Theme>;

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  function Stack(props, ref) {
    return <MuiStack ref={ref} {...extendSxProp(props)} />;
  },
);
